import { Component, OnInit, ChangeDetectionStrategy, forwardRef, ViewChild, Input, Inject } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { DropCombo } from '../../models/DropCombo';
import { switchMap, tap, delay, map } from 'rxjs/operators';
import { from } from 'rxjs';
import { DropdownGeneralService } from './dropdown-general.service';

@Component({
  selector: 'app-dropdown-general',
  templateUrl: './dropdown-general.component.html',
  styleUrls: ['./dropdown-general.component.css'],
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DropdownGeneralComponent),
      multi: true
    }
  ]
})
export class DropdownGeneralComponent implements OnInit, ControlValueAccessor {

  @ViewChild("drop", { static: true }) public drop: any;

  // Valor de entrada para actualizar el contenido del drop según el id de otro drop
  @Input() set controlId(controlId: any) {

    let hadValue: boolean = false;

    if (controlId) {
      this.service.cargarData(controlId);

      hadValue = true;
    } else {
      this.dataList = null;
      this.dataListFiltered = null;
    }

    this.dropValue = { id: null, nombre: this.label };
    this.ComponentValue = null;

    //this.onChange(this.ComponentValue);

    this.verifyError();

    if (hadValue) {
      this.onTouched();
      this.touched = true;
    }
  }

  @Input() label: string = 'Seleccione una opción';
  @Input() disabled: boolean = false;
  @Input() isRequired: boolean = false;
  @Input() filterable: boolean = true;
  @Input() showLength: boolean = false;

  private service;

  dataList: Array<DropCombo> = [];
  dataListFiltered: Array<DropCombo> = [];
  textField: string = 'nombre';
  valueField: string = 'id';
  error: boolean = false;
  touched: boolean = false;

  emptyItem: DropCombo;
  dropValue: DropCombo = { id: null, nombre: this.label };
  ComponentValue: number = null;

  onChange: any = () => { };
  onTouched: any = () => { };

  constructor(@Inject(DropdownGeneralService) service) {
    this.service = service;
  }

  ngOnInit() {
    this.emptyItem = { id: null, nombre: this.label};
    this.service.dataItemsBehaviorSubject.subscribe(data => {
      this.dataList = data;
      this.dataListFiltered = data;

      if (this.dataList.length > 0 && /*this.dropValue.id == null &&*/ this.ComponentValue != null) {
        let item = this.dataList.find(x => x.id == this.ComponentValue);
        if (item) {
          this.dropValue = item;
        }
      } else if (this.dataList.length == 1) { // Si hay un solo elemento en el dropdown se selecciona por defecto
        this.selectionChange(this.dataList[0]);
      } else {
        this.dropValue = this.emptyItem;
      }
      if (this.showLength) {
        this.emptyItem = { id: null, nombre: (this.label + " (" + this.dataList.length + ")") };
      }
    });
  }

  ngAfterViewInit() {
    const contains = value => s => s.nombre.toLowerCase().indexOf(value.toLowerCase()) !== -1;

    this.drop.filterChange.asObservable().pipe(
      switchMap(value => from([this.dataList]).pipe(
        tap(() => this.drop.loading = true),
        delay(500),
        map((data) => data.filter(contains(value)))
      ))
    ).subscribe(x => {
      this.dataListFiltered = x;
      this.drop.loading = false;
    });
  }

  writeValue(obj: any): void {
    if (obj) {
      this.ComponentValue = obj;

      if (this.dataList) {
        let item = this.dataList.find(x => x.id == obj);
        if (item) {
          this.dropValue = item;
          this.verifyError();
          return;
        }
      }
      this.verifyError();
      return;
    }

    this.ComponentValue = null;
    this.dropValue = this.emptyItem;
    this.verifyError();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  public selectionChange(value: any): void {
    if (value) {
      this.ComponentValue = value.id;
    } else {
      this.ComponentValue = null;
    }

    this.dropValue = value;

    this.onChange(this.ComponentValue);
    this.onTouched();
    this.touched = true;

    this.verifyError();
  }

  public blur(): void {
    this.touched = true;

    this.verifyError();
  }

  private verifyError() {
    if (this.isRequired && this.ComponentValue == null && this.touched) {
      this.error = true;
    } else {
      this.error = false;
    }
  }

  handleFilter(value) {
    if (value && this.dataList.length > 0) {
      this.dataListFiltered = this.dataList.filter((s) => s.nombre.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    } 
  }
}
